import React from 'react';
import { Button, Typography } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import EntityFormDialog from './common/EntityFormDialog';
import FormProduto from './FormProduto';

/// Ficha do produto em janela flutuante, usada pela lista de produtos.
/// `productId` edita; `duplicateFromId` abre como cópia; sem os dois, é cadastro novo.
/// `onPrev` / `onNext` navegam entre registros da lista sem fechar o modal.
export default function ProductFormDialog({
  open,
  productId = null,
  duplicateFromId = null,
  onClose,
  onSaved,
  onPrev = null,
  onNext = null,
  navLabel = null,
}) {
  const titulo = productId
    ? 'Editar produto'
    : duplicateFromId
      ? 'Duplicar produto'
      : 'Novo produto';

  const podeNavegar = Boolean(productId) && (onPrev || onNext);

  return (
    <EntityFormDialog
      open={open}
      title={titulo}
      subtitle={productId ? `Código interno ${productId}` : null}
      onClose={onClose}
      maxWidth="lg"
      fullHeight
      footer={
        podeNavegar ? (
          <>
            <Button
              startIcon={<ChevronLeftIcon />}
              disabled={!onPrev}
              onClick={onPrev || undefined}
            >
              Anterior
            </Button>
            <Typography variant="body2" color="text.secondary" sx={{ px: 1 }}>
              {navLabel || ''}
            </Typography>
            <Button
              endIcon={<ChevronRightIcon />}
              disabled={!onNext}
              onClick={onNext || undefined}
            >
              Próximo
            </Button>
          </>
        ) : null
      }
    >
      <FormProduto
        key={`${productId || 'novo'}-${duplicateFromId || ''}`}
        embedded
        productId={productId}
        duplicateFromId={duplicateFromId}
        onCancel={onClose}
        onSaved={onSaved}
      />
    </EntityFormDialog>
  );
}
